/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslocoModule, TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { SVGIconModule } from '../svg-icon/svg-icon.module';
import { TelemetryModule } from '../telemetry/telemetry.module';
import { availableLangs } from '../exports';

import { DevToolsComponent } from './dev-tools.component';

import { AeroModule } from '../../aero/aero.module';
import { AvatarModule } from '../avatar/avatar.module';
import { AngularTestingTranslations } from '../angular-testing-translations/angular-testing-translations.component';
import { BulbCommonModule } from '../../common/bulb-common.module';
import { ResumeContentSelectionModalComponent } from
  '../../resume/content-selection-modal/content-selection-modal.component';
import { ImageCarouselModule } from '../image-carousel/image-carousel.module';
import { MenusModule } from '../menus/menus.module';
import { ResumeModule } from '../../resume/resume.module';
import { RunMigratorsComponent } from './run-migrators/run-migrators.component';
import { ButtonStylesComponent } from './button-styles/button-styles.component';
import { MenuListDemosComponent } from './menu-list-demos/menu-list-demos.component';
import { AssetUploadsModule } from '../asset-uploads/asset-uploads.module';
import { UppyDashboardDemosComponent } from './uppy-dashboard-demos/uppy-dashboard-demos.component';
import { LtiNamesAndRolesComponent } from './lti-names-and-roles/lti-names-and-roles.component';
import { TestCustomDialogContentComponent } from './test-custom-dialog-content/test-custom-dialog-content.component';

const loader = availableLangs.reduce((acc, lang) => {
  acc[lang] = () => import(`~/resources/translations/locale-${lang}.json`);
  return acc;
}, {});

/**
 * Feature Module for our Dev Tools testing.
 */
@NgModule({
  declarations: [
    AngularTestingTranslations,
    ButtonStylesComponent,
    DevToolsComponent,
    LtiNamesAndRolesComponent,
    MenuListDemosComponent,
    RunMigratorsComponent,
    TestCustomDialogContentComponent,
    UppyDashboardDemosComponent,
  ],
  imports: [
    AeroModule,
    AssetUploadsModule,
    AvatarModule,
    BulbCommonModule,
    CheckboxModule,
    CommonModule,
    FormsModule,
    ImageCarouselModule,
    InputSwitchModule,
    MenusModule,
    ResumeModule,
    SVGIconModule,
    TelemetryModule,
    ToastModule,
    TranslocoModule,
    SvgIconComponent,
  ],
  providers: [
    [
      {
        provide: TRANSLOCO_SCOPE,
        useValue: {
          scope: 'ajs',
          loader,
        },
      },
    ],
  ],
})
export class DevToolsModule { }
